import { useTranslate } from '@va/localization';
import { ConfirmationDialogProps, ConfirmationModal } from '@va/shared/util-confirmation';
import { Paragraph } from '@va/ui/design-system';
import { useMemo } from 'react';

export const PendingWebsiteTrackingCodeDomainConfirmationModal: React.FC<ConfirmationDialogProps> = ({
  onClose,
  onConfirm,
}) => {
  const translate = useTranslate();

  const infoNode = useMemo(() => {
    return <Paragraph>{translate('standalone.customDomains.trackingCode.confirmCancel.line1')}</Paragraph>;
  }, [translate]);

  return (
    <ConfirmationModal
      info={infoNode}
      title={translate('standalone.customDomains.trackingCode.confirmCancel.title')}
      onClose={onClose}
      onConfirmation={onConfirm}
      isOpen={true}
      actionButtonText={translate('button.confirm')}
    />
  );
};
